import type { EditableComponent, CreatedComponent } from '../../common/model/types.tsx';
import componentHandler from '../../common/services/component-handler.tsx';
import { create as createRequest, type CreateRequestPayload } from '../rest/create.tsx';
import { transformComponent } from './transform.tsx';

type ProjectKey = string;

export const create = (
	projectId: number,
	projectKey: ProjectKey,
	component: EditableComponent,
): Promise<CreatedComponent> => {
	const { name, description, lead, defaultAssignee } = component;
	const componentLeadField = lead && { leadAccountId: lead.accountId };

	const payload: CreateRequestPayload = {
		name,
		description,
		assigneeType: defaultAssignee,
		project: projectKey,
		projectId,
		...componentLeadField,
	};

	return componentHandler(createRequest(payload), transformComponent, projectKey);
};
